import React from 'react';
import customAxios from '../../API/customAxios';
import moment from 'moment';

export async function getCashOutApproves(searchCutOffDate) {
    const cutOffDate = moment(toNativeDate(searchCutOffDate)).format('YYYY-MM-DD');
    const endpoint = `/get_cash_out_items?cutOffDate=${cutOffDate}`;

    return await customAxios.get(endpoint);
}

export async function getCashOutApprovalHistory(searchFromDate, searchToDate) {
    const startDate = moment(toNativeDate(searchFromDate)).format('YYYY-MM-DD');
    const endDate = moment(toNativeDate(searchToDate)).format('YYYY-MM-DD');

    return await customAxios.get(`/get_cash_out_record_details_by_date`, {
        params: {
            startDate,
            endDate,
        },
    });
}

export async function getCashOutApprovalSummary(searchFromDate, searchToDate) {
    const startDate = moment(toNativeDate(searchFromDate)).format('YYYY-MM-DD');
    const endDate = moment(toNativeDate(searchToDate)).format('YYYY-MM-DD');

    return await customAxios.get(`/get_cash_out_record_summary_by_date`, {
        params: {
            startDate,
            endDate,
        },
    });
}

export function toNativeDate(date) {
    return new Date(date.year, date.month - 1, date.day);
}
